// react-query keys in one place so event handlers can update the right cache entries.
export const qk = {
  session: ['session'] as const,
  projects: ['projects'] as const,
  project: (id: string) => ['project', id] as const,
  conversations: (projectId: string) => ['conversations', projectId] as const,
  conversation: (id: string) => ['conversation', id] as const,
  agents: (projectId: string) => ['agents', projectId] as const,
  agentVersions: (agentId: string) => ['agentVersions', agentId] as const,
  providers: ['providers'] as const,
  models: ['models'] as const,
  memory: (projectId: string) => ['memory', projectId] as const,
  server: (projectId: string) => ['server', projectId] as const,
  environment: (projectId: string) => ['environment', projectId] as const,
  audit: (projectId: string) => ['audit', projectId] as const,
  checkpoints: (projectId: string) => ['checkpoints', projectId] as const,
  integrations: (projectId: string) => ['integrations', projectId] as const,
  issues: (projectId: string) => ['issues', projectId] as const,
  features: (projectId: string) => ['features', projectId] as const,
  feature: (id: string) => ['feature', id] as const,
  usage: (days: number) => ['usage', days] as const,
  templates: ['templates'] as const,
  sessions: ['authSessions'] as const,
  passkeys: ['passkeys'] as const,
};
